import React,{useEffect,useState,useRef} from 'react';
import styled from 'styled-components';

import { AppState } from '../../store';
import { withRouter, useHistory } from 'react-router';
import { connect } from 'react-redux';
import { setCurrentCategory, setSubCategoriesStatus,getCategory, clone } from '../../store/categories/functions';

import { Card, CardActionButton, DescriptionBox, Button, ComponentModesEnum, DynamicForm } from '../elements';
import { finder, fetchPostItem, postPost, putPost } from '../../store/posts/functions';
import { Post } from '../../store/posts/types';
import FormViewItem, { FormViewItemEnum } from '../elements/formViewItem';
import { FormDataItem } from '../../store/forms/types';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

type PostItemEditComponentProps = {
    className?: string,
    match: any,
    onSetCurrentCategoryId: Function,
    onToggleSubCategories: Function,
    onFetchPostItem: Function,
    onPostPost: Function,
    onPutPost: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    currentPost?: Post
}

const PostItemEditComponent = (props: PostItemEditComponentProps) => {
    const [post, setPost] = useState<Post>()
    const [fields, setFields] = useState<FormDataItem[]>()
    let history = useHistory()

    useEffect(() => {
        props.onFetchPostItem(parseInt(""+props.match.params.postId));
    },[])

    useEffect(() => {
        if(props.currentPost) {
            setPost(props.currentPost)

            setFields([
              {
                id: "content",
                htmltype : "editor",
                label : "",
                defaultValue: props.currentPost.content,
                value: props.currentPost.content,
                disabled: false
              },
              {
                id: "images_ids",
                htmltype : "image",
                label : "تصاویر پیوست",
                value: props.currentPost.images,
                disabled: false
              }
            ])

        }
        return () => {};
    }, [props.currentPost])

    const submit = (data: any) => {
      if (!post) return
      let tempPost = clone(data);
      if(post.copyof == null || post.copyof == undefined) {
        tempPost.copyof = props.match.params.postId;
        props.onPostPost(parseInt(""+props.match.params.postId),tempPost,goBack)
      } else {
        tempPost.copyof = post.copyof;
        props.onPutPost(parseInt(""+props.match.params.postId),tempPost,goBack)
      }
    }
    const goBack = (obj:any) => {
      history.push(`/categories/${obj.category.id}/posts/${obj.id}/edit`);
    }
// coupyof put
    return (
      <div className={props.className}>
          {post &&
            <Card
              title={"ویرایش: "+post.title}
              headerMeta={<>
                <CardActionButton title="بازگشت" to={props.match.url.substring(0, props.match.url.lastIndexOf("/"))} iconClassName="icon-icons8-cancel" hasBorderRight={true}/>
              </>}
            >
              {post.description && <DescriptionBox content={<FroalaEditorView model={post.description} />} style={{margin:"20px 20px 0 20px"}}/>}
              {fields && <DynamicForm onSubmit={(data: any)=>submit(data)} isEdit={true} fields={fields}/>}
            </Card>
          }
        </div>

    )
}

const PostItemEdit = styled(PostItemEditComponent)`

`

const mapStateToProps = (state: AppState,ownProps: any) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,

  currentPost: findPost(ownProps.match.params.postId,state.posts.posts),
});

function findPost(postId: any,posts: Post[]) {
  if(!postId || !posts) return;
  let postIndex = finder(parseInt(""+postId),posts);
  return posts[postIndex];
}

const mapDispatchToProps = (dispatch:any) => {
    return {
      onSetCurrentCategoryId  : (id: number)      =>{
        dispatch(setCurrentCategory(id));
      },
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      },
      onFetchPostItem: (id: number) => {
        dispatch(fetchPostItem(id))
      },
      onPostPost: (id: number, post: Post, then?: Function)=>{
        dispatch(postPost(id,post,then))
      },
      onPutPost: (id: number, post: Post, then?: Function)=>{
        dispatch(putPost(id,post,then))
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(PostItemEdit));


          // <div className={props.className} style={{fontFamily:'dana',paddingLeft:29}}>
        //     {props.match.params.postId}.{postItem.title}
        //     <FroalaEditorComponent config={EditorConfig} model={model} onModelChange={(m:any)=>setModel(m)} tag='textarea'/>
        // </div>
        // Require Editor CSS files.
// import 'froala-editor/css/froala_style.min.css';
// import 'froala-editor/css/froala_editor.pkgd.min.css';
// import 'froala-editor/js/languages/fa';
// import 'froala-editor/js/plugins.pkgd.min.js';
// ///<reference path= "./../../inc/froala.d.ts" />
// import FroalaEditorComponent from 'react-froala-wysiwyg';

// const EditorConfig = {
//   language: 'fa',
// }